import React from 'react';

const Menu = (props) => (
  <svg width='20' height='12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 12h20v-2H0v2Zm0-5h20V5H0v2Zm0-7v2h20V0H0Z'
      fill='var(--cvna-color-blue-6)'
    />
  </svg>
);

export default Menu;
